import React from "react";
import { useTranslation } from "react-i18next";

export const WebsiteField = ({ field, form }) => {
    const { t } = useTranslation();

    const handleChange = (e) => {
        form.setFieldValue("website", `${e.target.value}.cheqit.app`);
        form.setFieldValue("cheqit_domain", e.target.value);
    };

    return (
        <input
            type="text"
            name={field.name}
            value={field.value || ""}
            onChange={handleChange}
            onBlur={field.onBlur}
            placeholder={t("Website URL")}
            className="input mt-1 border-none focus:ring-gray-200  focus:border-gray-100 bg-gray-50 block w-full shadow-sm sm:text-sm rounded-md"
        />
    );
};
